import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageStatusCodeList extends Layout {
    layoutheaderBrokStatusCodeList: LayoutHeader;
    sourceBrokerageStatusCode: DataSource;
    tableSearch: Table;
}
